import { TOKEN_KEY } from 'services';
import { storage } from 'utils';

export const useAuth = () => {
  const token = storage.get(TOKEN_KEY);
  const isAuthenticated = !!token;
  return [typeof isAuthenticated === 'boolean', isAuthenticated];
};
